export default "__VITE_ASSET__1GlY8ZQ9__"